module.exports = __webpack_public_path__ + "static/media/gift.4046f33e.svg";